import { message, Progress } from 'antd';
import React, { memo, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';

import api from '../../services/api';
import { ModalAttendance } from '../ModalAttendance';
import stop from '../../assets/icons/stop.svg';

function Cron({
  secondsScreen,
  minutesScreen,
  minutes,
  title,
  idAtendimento,
  tipoAtendimento,
  observacaoInterna,
}) {
  const [segundosCron, setSegundosCron] = useState(0);
  const [minutosCron, setMinutosCron] = useState(0);
  const [corrido, setCorrido] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [validateClick, setValidateClick] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [textModal, setTextModal] = useState('');
  const history = useHistory();
  const handleCancel = () => cancelModal();

  const segundosFormatados =
    +segundosCron < 10 ? `0${+segundosCron}` : +segundosCron;
  const minutosFormatados =
    +minutosCron < 10 ? `0${+minutosCron}` : +minutosCron;
  document.title = `${minutosCron}:${segundosCron} - ${title}`;

  function toggle() {
    setIsActive(!isActive);
    setIsModalVisible(true);
  }

  function cancelModal() {
    setIsActive(!isActive);
    setIsModalVisible(false);
  }

  const explainModal = text => {
    setTextModal(text.target.value);
    text.target.value?.trim()?.length >= 10 && setValidateClick(false);
    text.target.value?.trim()?.length <= 9 && setValidateClick(true);
  };

  const handleOk = async e => {
    const defaultError = 'Error ao tentar encerrar atendimento.';
    const payload = {
      idAtendimento,
      motivo: textModal,
      observacaoInterna,
    };

    try {
      setIsLoading(true);
      const response = await api.put('/Atendimento/Encerrar', payload);
      if (response?.data) {
        message.success('Atendimento encerrado com sucesso!');
        if (tipoAtendimento === 1) {
          return history.push('/painel-de-controle');
        }

        if (tipoAtendimento === 2) {
          return history.push('/consultas-externas-painel');
        }
        setIsLoading(false);
      }
      if (!response?.data) {
        setIsLoading(false);
        return message.error(defaultError);
      }
    } catch (error) {
      setIsLoading(false);
      const erro = { error };
      message.error(erro?.error?.response?.data?.detail || defaultError);
      if (
        erro?.error?.response?.data?.detail.includes(
          'O atendimento já está finalizado!'
        )
      )
        history.push('/painel-de-controle');
    }
    // setIsLoading(true);
  };

  useEffect(() => {
    setSegundosCron(secondsScreen);
    setMinutosCron(minutesScreen);
  }, [secondsScreen, minutesScreen, minutes]);

  useMemo(() => {
    const totalForSeconds = +minutes * 60;
    const totalPercorrido = +minutosCron * 60 + segundosCron;
    const totalPercent = (
      (+totalPercorrido / +totalForSeconds) *
      100
    ).toFixed();
    setCorrido(totalPercent);
  }, [minutes, segundosCron, minutosCron]);

  useEffect(() => {
    start();
  }, []);

  const start = () => {
    setInterval(() => {
      setSegundosCron(seconds => seconds + 1);
    }, [1000]);
  };

  if (segundosCron >= 60) {
    setSegundosCron(0);
    setMinutosCron(minutosCron => minutosCron + 1);
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        position: 'relative',
      }}
    >
      <ModalAttendance
        visible={isModalVisible}
        cancelBtn={handleCancel}
        okBtn={handleOk}
        explain
        changeText={explainModal}
        disabled={validateClick}
        title="Deseja abandonar o atendimento atual?"
        titleExplain="Escreva abaixo o motivo"
        loadingModal={isLoading}
      />
      <img
        style={{
          position: 'relative',
          marginRight: '16px',
          cursor: 'pointer',
        }}
        alt="stop"
        src={stop}
        onClick={toggle}
      />
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '420px',
          minWidth: 0,
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '48px minmax(0, 1fr) 58px',
            gap: '8px',
            alignItems: 'center',
            marginBottom: '5px',
            color: '#3e3e3e',
            fontSize: '12px',
          }}
        >
          <span style={{ fontWeight: 'bold', textAlign: 'left' }}>
            {`${corrido >= 100 ? 100 : corrido}%`}
          </span>
          <span
            style={{
              overflow: 'hidden',
              textAlign: 'center',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {title || 'Progresso'}
          </span>
          <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
            {`${minutosFormatados}:${segundosFormatados}`}
          </span>
        </div>
        <Progress
          showInfo={false}
          percent={corrido}
          strokeColor={{
            '0%': '#24A95D',
            '60%': '#24A95D',
            '100%': '#D42929',
          }}
          style={{ display: 'block', lineHeight: 1, margin: 0 }}
        />
      </div>
    </div>
  );
}

export default memo(Cron);
